'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconCog = require('@cimpress-technology/react-streamline-icons/lib/IconCog');

var _IconCog2 = _interopRequireDefault(_IconCog);

var _Modal = require('@cimpress/react-components/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _NavTab = require('@cimpress/react-components/lib/NavTab');

var _NavTab2 = _interopRequireDefault(_NavTab);

var _NavTabItem = require('@cimpress/react-components/lib/NavTabItem');

var _NavTabItem2 = _interopRequireDefault(_NavTabItem);

var _Spinner = require('@cimpress/react-components/lib/shapes/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _SettingsClient = require('../SettingsClient');

var _GlobalSettings = require('./GlobalSettings');

var _GlobalSettings2 = _interopRequireDefault(_GlobalSettings);

var _languages = require('../constants/languages');

var _reactI18next = require('react-i18next');

var _i18n = require('../i18n');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var GLOBAL_TAB = 'GLOBAL';
var APP_TAB = 'APP';

var SettingsModal = function (_Component) {
  _inherits(SettingsModal, _Component);

  function SettingsModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SettingsModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SettingsModal.__proto__ || Object.getPrototypeOf(SettingsModal)).call.apply(_ref, [this].concat(args))), _this), _this.loadGlobalSettings = function () {
      _this.setState({
        loading: true
      });

      (0, _SettingsClient.getSettings)(_this.props.authToken, _this.props.supportedLanguages).then(function (settings) {
        var _ref2 = settings.global || {},
            language = _ref2.language,
            regionalSettings = _ref2.regionalSettings,
            timezone = _ref2.timezone;

        _this.setState({
          language: language,
          locale: regionalSettings,
          timeZone: timezone,
          loading: false
        });
      }).catch(function (error) {
        _this.setState({
          loading: false
        });

        console.warn(error);
      });
    }, _this.state = {
      loading: false,
      showModal: false,
      language: undefined,
      locale: undefined,
      timeZone: undefined,
      selectedTab: _this.props.appSettingsContent ? APP_TAB : GLOBAL_TAB
    }, _this.open = function () {
      _this.props.onOpen();

      _this.setState({
        showModal: true
      });

      _this.loadGlobalSettings();
    }, _this.close = function () {
      return _this.setState({
        showModal: false
      });
    }, _this.selectAppTab = function () {
      return _this.setState({
        selectedTab: APP_TAB
      });
    }, _this.selectGlobalTab = function () {
      return _this.setState({
        selectedTab: GLOBAL_TAB
      });
    }, _this.onLanguageUpdated = function (language) {
      return _this.setState({
        language: language
      });
    }, _this.onLocaleUpdated = function (locale) {
      return _this.setState({
        locale: locale
      });
    }, _this.onTimeZoneUpdated = function (timeZone) {
      return _this.setState({
        timeZone: timeZone
      });
    }, _this.canSave = function () {
      var _this$state = _this.state,
          language = _this$state.language,
          locale = _this$state.locale,
          timeZone = _this$state.timeZone;
      return Boolean(language && locale && timeZone && _this.props.canSave);
    }, _this.cancel = function () {
      _this.props.onCancel();

      _this.close();
    }, _this.save = function () {
      var _this$state2 = _this.state,
          language = _this$state2.language,
          locale = _this$state2.locale,
          timeZone = _this$state2.timeZone;

      _this.setState({
        loading: true
      });

      (0, _SettingsClient.putGlobalSettings)(_this.props.authToken, language, locale, timeZone).then(function () {
        _this.setState({
          loading: false
        });

        _this.props.onSave();

        _this.close();
      }).catch(function (error) {
        _this.setState({
          loading: false
        });

        console.warn(error);
      });
    }, _this.tt = function (key) {
      var _this$props = _this.props,
          t = _this$props.t,
          lang = _this$props.lang;
      return t(key, {
        lng: lang
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SettingsModal, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          selectedTab = _state.selectedTab,
          loading = _state.loading,
          language = _state.language,
          locale = _state.locale,
          timeZone = _state.timeZone;
      var _props = this.props,
          lang = _props.lang,
          appSettingsContent = _props.appSettingsContent,
          supportedLanguages = _props.supportedLanguages;
      return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement('a', {
        className: 'clickable',
        onClick: this.open
      }, _react2.default.createElement(_IconCog2.default, null)), _react2.default.createElement(_Modal2.default, {
        show: this.state.showModal,
        onRequestHide: this.cancel,
        closeButton: true,
        title: this.tt('modal_title'),
        footer: _react2.default.createElement(_react.Fragment, null, _react2.default.createElement('button', {
          className: 'btn btn-default',
          onClick: this.cancel
        }, this.tt('modal_button_cancel_title')), _react2.default.createElement('button', {
          className: 'btn btn-primary',
          onClick: this.save,
          disabled: loading || !this.canSave()
        }, this.tt('modal_button_save_title')))
      }, _react2.default.createElement('div', null, appSettingsContent ? _react2.default.createElement(_NavTab2.default, null, _react2.default.createElement(_NavTabItem2.default, {
        active: selectedTab === APP_TAB
      }, _react2.default.createElement('button', {
        style: {
          marginLeft: 0,
          paddingLeft: 0
        },
        onClick: this.selectAppTab
      }, this.props.appSettingsTitle || this.tt('app_settings_title'))), _react2.default.createElement(_NavTabItem2.default, {
        active: selectedTab === GLOBAL_TAB
      }, _react2.default.createElement('button', {
        onClick: this.selectGlobalTab
      }, this.tt('global_settings_title')))) : null, loading ? _react2.default.createElement(_Spinner2.default, {
        className: 'flex-center'
      }) : selectedTab === APP_TAB ? appSettingsContent : _react2.default.createElement(_GlobalSettings2.default, {
        lang: lang,
        language: language,
        onLanguageUpdated: this.onLanguageUpdated,
        locale: locale,
        onLocaleUpdated: this.onLocaleUpdated,
        timeZone: timeZone,
        onTimeZoneUpdated: this.onTimeZoneUpdated,
        supportedLanguages: supportedLanguages
      }))));
    }
  }]);

  return SettingsModal;
}(_react.Component);

SettingsModal.propTypes = {
  lang: _propTypes2.default.string,
  authToken: _propTypes2.default.string.isRequired,
  appSettingsTitle: _propTypes2.default.node,
  appSettingsContent: _propTypes2.default.node,
  canSave: _propTypes2.default.bool,
  onOpen: _propTypes2.default.func,
  onSave: _propTypes2.default.func,
  onCancel: _propTypes2.default.func,
  supportedLanguages: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(_languages.languageCodes))
};
SettingsModal.defaultProps = {
  lang: 'en',
  canSave: true,
  onOpen: function onOpen() {},
  onSave: function onSave() {},
  onCancel: function onCancel() {},
  supportedLanguages: _languages.languageCodes
};
var SettingsModalWithTranslation = (0, _reactI18next.withTranslation)('react-platform-settings')(SettingsModal);

exports.default = function (props) {
  return _react2.default.createElement(SettingsModalWithTranslation, _extends({
    i18n: (0, _i18n.getI18nInstance)()
  }, props));
};